import type { Container } from "inversify";
import { type IModule, Logger } from "@designboticteam/core";
import { DxfExportService } from "./services/DxfExportService";
import { ExportService } from "./services/ExportService/ExportService";

class ExchangeModule implements IModule {
	public readonly moduleName = "ExchangeModule";
	private readonly logger = new Logger(`🚀 ${this.moduleName}`, { color: "#ffffff", backgroundColor: "#00ff00" });

	#exportService?: ExportService;
	private get exportService() {
		if (this.#exportService === undefined) {
			throw new Error("Export service is not initialized");
		}

		return this.#exportService;
	}

	#dxfExportService?: DxfExportService;
	private get dxfExportService() {
		if (this.#dxfExportService === undefined) {
			throw new Error("DXF export service is not initialized");
		}

		return this.#dxfExportService;
	}

	constructor() {
		this.logger.log("constructed");
	}

	public register(container: Container): void {
		container.bind(ExportService).toSelf().inSingletonScope();
		container.bind(DxfExportService).toSelf().inSingletonScope();

		this.logger.log("registered");
	}

	public initialize(container: Container): void {
		this.#exportService = container.get(ExportService);
		this.#dxfExportService = container.get(DxfExportService);
		// Initialize services here
		this.logger.log("initialized");
	}

	public dispose(): void {
		// Dispose services here
		this.logger.log("disposed");
	}

	public get api() {
		return {
			exchange: {
				prepareExport: this.exportService.prepareExport.bind(this.exportService),
				exportProjectArea: this.exportService.requestProjectAreaExport.bind(this.exportService),
				exportDxf: this.dxfExportService.buildDxf.bind(this.dxfExportService),
				onExportRequested: this.exportService.onExportRequested,
				onExportSucceeded: this.exportService.onExportSucceeded,
				onExportFailed: this.exportService.onExportFailed,
			},
		};
	}
}

export { ExchangeModule };
